import React from 'react';
import { Text, Button } from '@radix-ui/themes';
import caseStudy from "../../../assets/images/caseStudy.png";

interface CsStartPresenterProps {
  onPress: () => void;
  nominationType: 'Group' | 'GroupLeader';
}

const CsStartPresenter: React.FC<CsStartPresenterProps> = ({ onPress, nominationType }) => {
  console.log('nominateType::::', nominationType);
  const nominator =
    nominationType === 'Group'
      ? 'Your group members have'
      : nominationType === 'GroupLeader'
      ? 'Your group leader has'
      : '';

  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <img
        src={caseStudy}
        alt="Case Study"
        className="h-[20vh] w-[35vw] object-contain"
      />
      <Text className="text-white py-4 text-center font-[Lato-Regular] text-base w-[60vw] mb-4">
        {`${nominator} nominated you as Presenter\n\nStart your presentation prep NOW`}
      </Text>
      <Button
        onClick={onPress}
        className="bg-blue-600 hover:bg-blue-700 text-white font-[Lato-Regular] text-sm rounded-lg py-2 px-7 shadow-md mb-4"
      >
        OK
      </Button>
    </div>
  );
};

export default CsStartPresenter;